
document.addEventListener('click', (e) => {
  const thumb = e.target.closest('[data-thumb-src]');
  if (!thumb) return;

  const card = thumb.closest('[data-product-card]');

  const image = card?.querySelector('.pcard__media img, .product-card__media img');
  if (!image) return;

  image.src = thumb.dataset.thumbSrc;
  image.removeAttribute('srcset');   

  if (thumb.dataset.thumbUrl) {
    card.querySelectorAll('a[href]').forEach((a) => {
      if (a.classList.contains('pcard__media') || a.classList.contains('pcard__title')
          || a.classList.contains('product-card__media') || a.classList.contains('product-card__title')) {
        a.href = thumb.dataset.thumbUrl;
      }
    });
  }

  card.querySelectorAll('[data-thumb-src]').forEach((t) => t.classList.toggle('is-active', t === thumb));
});

document.addEventListener('click', async (e) => {
  const btn = e.target.closest('[data-card-add]');
  if (!btn) return;

  const id = Number(btn.dataset.cardAdd);
  if (!id) return;

  const card = btn.closest('[data-product-card]');
  const qtyEl = card?.querySelector('[data-qty-value]');
  const quantity = Math.max(1, parseInt(qtyEl?.value, 10) || 1);

  const labelNode = btn.querySelector('span:not([class])')
    || [...btn.childNodes].find((n) => n.nodeType === 3 && n.textContent.trim());
  const setLabel = (text) => { if (labelNode) labelNode.textContent = text; };
  const was = labelNode ? labelNode.textContent : '';
  btn.disabled = true;
  setLabel(window.themeStrings?.addedToCart || was);
  try {
    await window.CartAPI.add([{ id, quantity }], { source: 'card-add' });
  } catch (err) {
    setLabel(window.themeStrings?.cartError || was);
  } finally {
    setTimeout(() => { setLabel(was); btn.disabled = false; }, 1400);
  }
});

/* ═══════════ СКІЛЬКИ РЯДКІВ ЗАЙНЯЛА НАЗВА (data-title-lines) ═══════════
 *
 * Вимога власника: опис у картці обрізаний 3 рядками, а якщо НАЗВА лягла у
 * два рядки - то 2, щоб блок «назва + опис» завжди мав ту саму висоту й
 * ціна з кнопкою стояли на одній лінії в усіх картках ряду. Самі висоти,
 * обрізку й проміжки рахує CSS (theme-sections-css/card-tile.css); звідси
 * потрібне ОДНЕ число, якого CSS не знає: назва - це один рядок чи два.
 *
 * Міряємо висотою елемента, поділеною на інтерліньяж. Назва обрізана
 * `-webkit-line-clamp: 2`, тож у трирядкової назви вийдуть ті самі 2 - нам
 * і треба лише «1 чи не 1».
 *
 * КОЛИ переміряємо, і чому без setInterval:
 *   - ResizeObserver на самій назві - закриває і довантаження шрифта
 *     PCTL9600 (перенос слів у ньому інший, ніж у системному), і зміну
 *     ширини вікна, і момент, коли картка зі схованого блока (дравер
 *     кошика, неактивний слайд) стає видимою. Атрибут міняє обрізку ОПИСУ
 *     й проміжок, а не бокс назви, тож спостерігач сам себе не збуджує.
 *   - MutationObserver - щоб почепити спостерігача на картки, яких при
 *     завантаженні не було: каталог довантажує товари кнопкою, смуги
 *     рекомендацій і «ви дивились» підтягуються запитом після load,
 *     дравер кошика перемальовує свою смугу.
 *   - `infinite:loaded` (assets/infinite-list.js, bubbles) - явний хук теми
 *     на довантаження сітки: дешевший за чекання черги MutationObserver.
 */
(() => {
  const ro = 'ResizeObserver' in window
    ? new ResizeObserver((entries) => entries.forEach((e) => mark(e.target)))
    : null;
  const seen = new WeakSet();

  function mark(title) {
    const card = title.closest('.pcard');
    if (!card) return;
    const h = title.getBoundingClientRect().height;
    if (!h) return;                      // схована картка - переміряємо, коли покажуть
    const cs = getComputedStyle(title);
    const lh = parseFloat(cs.lineHeight) || parseFloat(cs.fontSize) * 1.2;
    if (!lh) return;
    if (h > lh * 1.5) card.setAttribute('data-title-lines', '2');
    else card.removeAttribute('data-title-lines');
  }

  function scan(root) {
    const list = (root instanceof Element && root.matches?.('.pcard'))
      ? [root] : (root.querySelectorAll ? [...root.querySelectorAll('.pcard')] : []);
    list.forEach((card) => {
      const title = card.querySelector('.pcard__title');
      if (!title) return;
      mark(title);
      if (ro && !seen.has(title)) { seen.add(title); ro.observe(title); }
    });
  }

  const all = () => scan(document);

  all();
  document.addEventListener('DOMContentLoaded', all);
  if (document.fonts?.ready) document.fonts.ready.then(all);
  document.addEventListener('infinite:loaded', all);

  if ('MutationObserver' in window) {
    let queued = false;
    new MutationObserver((muts) => {
      if (queued) return;
      const fresh = muts.some((m) => [...m.addedNodes].some(
        (n) => n.nodeType === 1 && (n.matches?.('.pcard') || n.querySelector?.('.pcard'))
      ));
      if (!fresh) return;
      queued = true;
      requestAnimationFrame(() => { queued = false; all(); });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  /* Без ResizeObserver (старий WebKit) зміну ширини ловимо вручну - і лише
     коли змінилась саме ШИРИНА: на мобілках resize сипле на кожну появу
     адресного рядка, а від висоти вікна перенос назви не залежить. */
  if (!ro) {
    let w = innerWidth;
    let t = 0;
    addEventListener('resize', () => {
      if (innerWidth === w) return;
      w = innerWidth;
      clearTimeout(t);
      t = setTimeout(all, 150);
    });
  }
})();
